import React from 'react'

import Banner from './components/Banner'
import Card from './components/Card'
import BannerMultimedia from './components/BannerMultimedia'
import CardComplementary from './components/CardComplementary'
import News from './components/News'
import BannerIdera from './components/BannerIdera'
import Spacer from '../../components/Spacer'
function Home() {
  return (
    <>
    <Banner/>
    <Spacer/>
    <Card/>
    <Spacer/>
    <BannerMultimedia/>
    <Spacer/>
    <CardComplementary/>
    <Spacer/>
    <News/>
    <Spacer/>
    <BannerIdera/>
    

    </>
  )
}

export default Home